import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';

import { TDealFeaturesModalContainerProps } from './types';
import { DealFeaturesModalHeader, DealFeaturesModalContent } from './components';
import { setCommonDealDetailsModalId } from '../../actions';
import { TCommonDealDetailKeys } from '../../types/promoInfo';
import { trackCommonDealDetailsModalOpen } from '../../utils/analytics';
import { selectCommonDealDetails } from '../../selectors/promoInfo';
import { ConsultationRequestButtonContainer } from '../ConsultationRequestButtonContainer';

export const DealFeaturesModalContainer: React.FC<
  React.PropsWithChildren<TDealFeaturesModalContainerProps>
> = props => {
  const dispatch = useDispatch();
  const commonDealDetails = useSelector(selectCommonDealDetails);

  if (!props.open) {
    return null;
  }

  const { title, description, details, onClose } = props;

  const onContentClick = (e: React.MouseEvent) => {
    const element = e.target as HTMLAnchorElement;

    /* istanbul ignore else */
    if (element.dataset.modalLink) {
      e.preventDefault();
      const modalId = element.hash.slice(1) as TCommonDealDetailKeys;

      trackCommonDealDetailsModalOpen(props.title, commonDealDetails[modalId].title);
      dispatch(setCommonDealDetailsModalId(modalId));
    }
  };

  return (
    <ModalFullscreen open onClose={onClose}>
      <DealFeaturesModalHeader onClose={onClose} />
      <DealFeaturesModalContent
        title={title}
        description={description}
        details={details}
        onContentClick={onContentClick}
        action={
          <ConsultationRequestButtonContainer size="M" fullWidth theme="fill_primary">
            Получить консультацию
          </ConsultationRequestButtonContainer>
        }
      />
    </ModalFullscreen>
  );
};
